/**
 * Shown only while a brand dry-run is active (`?brand=suprai`, non-production).
 * It has to be unmistakable: the whole site is wearing a brand that has not
 * been cut over yet.
 */
import React from 'react';
import { FlaskConical } from 'lucide-react';
import brand, { configuredBrand, isBrandPreview } from '../brand/brand';

export default function BrandPreviewRibbon() {
  if (!isBrandPreview) return null;

  const exit = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('brand', 'off');
    window.location.assign(url.toString());
  };

  return (
    <div className="brand-ribbon" role="status" data-testid="brand-preview-ribbon">
      <FlaskConical size={15} aria-hidden="true" />
      <span className="brand-ribbon__label">Brand preview</span>
      <span className="brand-ribbon__text">
        Showing <strong>{brand.legalName}</strong>. The site is still configured as{' '}
        {configuredBrand.legalName}.
      </span>
      <button type="button" onClick={exit} data-testid="brand-preview-exit">
        Exit
      </button>
    </div>
  );
}
